/**
 * Sync-engine version helpers.
 *
 * Frontend source is split by version — prefer editing V2 trees:
 * - LogV1 / LogV2
 * - EconomicV1 / EconomicV2
 * - SetupV1 / SetupV2
 * - common/api/functions/v1|v2
 *
 * Route folders Economic/, Log/, Setup/ are thin version routers only.
 *
 * When admin impersonates a user, version comes from the switched user
 * (ACCOUNT_SWITCH_USER), not the admin ACCOUNT.
 */
import {config} from "../../config";
import {QHelpers} from "./index";

export type SyncEngineVersion = 'v1' | 'v2';

const resolveVersion = (user: any): SyncEngineVersion => {
    const version =
        user?.sync_engine_version
        ?? user?.setup?.sync_engine_version;

    return version === 'v2' ? 'v2' : 'v1';
};

export const getSyncEngineVersion = (): SyncEngineVersion => {
    try {
        if (QHelpers.store.getImpersonationToken()) {
            const switchedUser = QHelpers.store.getImpersonationUser();
            if (switchedUser) {
                return resolveVersion(switchedUser);
            }
        }

        const raw = localStorage.getItem(config.LOCAL_STORE.ACCOUNT);
        if (!raw) {
            return 'v1';
        }
        const account = JSON.parse(raw);
        return resolveVersion(account?.user ?? account);
    } catch {
        return 'v1';
    }
};

export const isSyncEngineV2 = (): boolean => getSyncEngineVersion() === 'v2';
